import React from 'react';
import RatingSmiley from '@prisjakt/ui-rating/src/smiley-rating';
import { Store } from 'src/types';
import { Rating } from '@prisjakt/ui-rating/src/types';
import { RatingContainer } from './styles';

interface IStoreRatingAverage {
  store?: Store | null;
  rating?: Rating;
  showReviewCount?: boolean;
}

export const StoreRatingAverage: React.FC<IStoreRatingAverage> = props => {
  const { store, rating, showReviewCount } = props;
  if (!store || !rating || rating.whole <= 0) {
    return null;
  }
  return (
    <RatingContainer data-rating={rating.roundedString}>
      <RatingSmiley
        featured={Boolean(store.featured)}
        rating={rating}
        reviewCount={
          showReviewCount ? store.userReviewSummary.countTotal : null
        }
        scoreVisibility="row"
        size="small"
      />
    </RatingContainer>
  );
};
